import { createContext } from 'react';
export interface ClientSecretContextType {
  clientSecret: string | null;
  setClientSecret: (secret: string | null) => void;
}

export const ClientSecretContext = createContext<ClientSecretContextType | undefined>(undefined);
